<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar porcentaje de eficiencia</h5>
          <button type="button" @click="closeModal" style="background: none; border: none; font-size: 1.5rem; line-height: 1;">&times;</button>
        </div>
        <div v-if="isLoading" style="padding: 5ch 0">
          <SpeenComponent
              :isAutomatic="true"
              :ringWidth="14"
              :spinnerSize="15"
              :isverticalAligned="true"
          />
        </div>
        <div class="modal-body" v-else>
          <form @submit.prevent="saveMachine">
            <div class="form-group">
              <label for="edit-code-input">Porcentaje de eficiencia:</label>
              <input v-model="form.efficiency_pct" id="edit-efficiency-pct-input" required class="form-control" ref="firstInput" type="number" min="1"/>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
                <button type="button" class="btn btn-secondary me-2" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-danger">Guardar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
  name: 'MachineEditModal',
  components: {
    SpeenComponent
  },
  props: {
    machineId: { type: Number, required: true }
  },
  data() {
    return {
      form: {
        ext_pk: null,
        efficiency_pct: 0,
      },
      isLoading: true
    };
  },
  methods: {
    loadMachine() {
      this.isLoading = true;
      axios.get(`/api/machine/get-data/${this.machineId}`)
        .then(response => {
          const data = response.data;
          this.form = {
            id: this.machineId,
            efficiency_pct: data.efficiency_pct || 0,
          };
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateMachine() {
      this.isLoading = true;
      axios.patch(`/api/machine/admon/${this.machineId}`, this.form)
        .then(() => {
          showCustomSuccessSweetAlert('Porcentaje de eficiencia editado correctamente');
          this.$emit('refresh-list');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    saveMachine() {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡Está acción afectará a los cálculos de tiempo de las órdenes activas y en cola relacionadas con esta máquina!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: 'red',
        }).then((result) => {
          if (result.isConfirmed) {
            this.updateMachine();
          }
      })
    },
    closeModal() {
      this.$emit('close-modal');
    },
  },
  mounted(){
    this.loadMachine();
  }
};
</script>
